<template>
  <Button
    color="primary"
    variant="outlined"
    data-test-id="buy-box-waitlist-button"
    class="px-2 py-1 rounded-md grow h-min box-border text-xs flex items-center hover:bg-white hover:text-teal-900 relative group border-gray-200 shadow-none!"
    @click="handleClick"
  >
    <BellFilledIcon
      class="w-[18px] h-[18px] transition-opacity duration-200 opacity-0 group-hover:opacity-100"
    />
    <BellEmptyIcon
      class="w-[18px] h-[18px] absolute transition-opacity duration-200 group-hover:opacity-0"
    />

    <span v-show="displayLabel" ref="waitlistLabel" class="ml-1 mt-0.5">
      {{ $t('product.show.noAvailableDatesBox.ctaTextOnlyWaitlist') }}
    </span>
  </Button>
</template>
<script lang="ts" setup>
import BellEmptyIcon from '~/assets/icons/event/bell-stroke.svg?component'
import BellFilledIcon from '~/assets/icons/event/bell-fill.svg?component'

const { toggleWaitlistSidebar } = useUiState()

const emit = defineEmits(['click:waitlist'])
const waitlistLabel = ref()

const { displayLabel = true } = defineProps<{
  displayLabel?: boolean
}>()

const handleClick = () => {
  emit('click:waitlist')
  toggleWaitlistSidebar()
}
</script>
